(() => {
  const selector = ".bc-card-image, .bd-photo, .bnm-parts__image, .bruno-arrivals__media, .bc-promo__product-image, .ba-promo__image, .ba-promo__rim-frame, .ba-promo__scene--photo, .rz-category-image, .bruno-hero-engine-part, .bruno-sportbike__image, .bruno-sportbike__engine-part, .resource-card[data-resource-type=\"product\"] .resource-card__media, .card-gallery .product-media, .product-media-container--image .product-media, .cart-items__media-container, media-gallery .slideshow-controls__thumbnail, .dialog-thumbnails-list__thumbnail, .ba-promo__wheel";
  let active = null;
  let pointerId = null;
  let releaseTimer;

  const clear = () => {
    window.clearTimeout(releaseTimer);
    active?.classList.remove('bruno-watermark-touch');
    active = null;
    pointerId = null;
  };

  document.addEventListener('pointerdown', (event) => {
    if (!['touch', 'pen'].includes(event.pointerType) || event.isPrimary === false) return;
    clear();
    if (!(event.target instanceof Element)) return;
    const watermark = event.target.closest(selector);
    if (!watermark?.querySelector(':scope > img')) return;
    active = watermark;
    pointerId = event.pointerId;
    active.classList.add('bruno-watermark-touch');
  }, { passive: true });

  document.addEventListener('pointerup', (event) => {
    if (event.pointerId !== pointerId) return;
    pointerId = null;
    releaseTimer = window.setTimeout(clear, 180);
  }, { passive: true });

  document.addEventListener('pointercancel', (event) => {
    if (event.pointerId === pointerId) clear();
  }, { passive: true });

  window.addEventListener('pagehide', clear);
  window.addEventListener('blur', clear);
})();
